$("swiper-component .testimonials-list").each(function(index, element){
    var $this = $(this);
    $this.addClass("instance-" + index);
    $this.find(".swiper-button-prev").addClass("btn-prev-" + index);
    $this.find(".swiper-button-next").addClass("btn-next-" + index);
    var swiper = new Swiper(".instance-" + index, {
        // your settings ...
        nextButton: ".btn-next-" + index,
        prevButton: ".btn-prev-" + index
    });
});




if($(window).width() < 1024) {
  function all_category() {
$(".nav-slider-section").clone().insertAfter("header-drawer");
$('header .all-categories').addClass('all-category-mobile-menu');
$('header .all-categories').on('click', function() {
$("header .slider-navigation").slideToggle("slow");
});

$('.nav__sub').prepend('<li class="nav__item"><a class="nav__link sub__close" href="#"><i class="fas fa-chevron-left"></i> Back</a></li>');

$('.sub__close').click(function(e) {
	e.preventDefault();	
	$(this).parent().parent().removeClass('is-active');
});

$('.nav__link').click(function(e) {
	e.preventDefault();	
	$(this).siblings().addClass('is-active');
});    
  }  
}


if($('#preloader').length > 0) {  
$(window).on('load', function() {
$( "#preloader" ).delay(350).fadeOut( "slow", function() {
if($('.preloader-overflow').length > 0) {
$('body').removeClass('preloader-overflow');   
}
});
});
}


InitCustomFunctions();
function InitCustomFunctions() { 
document.addEventListener('DOMContentLoaded', (event) => {
  const viewExists = document.querySelector('.grid-view-button');
  if(!viewExists) return;
  if (viewExists.classList.contains('layout-mode')) {
  const listViewButton = document.querySelector('.list-view-button');
  const gridViewButton = document.querySelector('.grid-view-button');
  const list = document.querySelector('ul.view-mode');

  listViewButton.onclick = function () {
  listViewButton.classList.add('active');
  gridViewButton.classList.remove('active');
  list.classList.remove('grid-view-filter');
  list.classList.add('list-view-filter');
  }

  gridViewButton.onclick = function () {
  listViewButton.classList.remove('active');
  gridViewButton.classList.add('active');
  list.classList.remove('list-view-filter');
  list.classList.add('grid-view-filter');
  }

  }
});

  
//Quantity selector on product grid                
if($('.grid-qty').length > 0)    {
      $('.grid-qty').each(function(){
      $(this).find('.btn-number').on('click', function (e) {
        e.preventDefault();
        fieldName = $(this).attr('data-field');
        type = $(this).attr('data-type');                                
        var input = $(this).closest(".product-form__item--quantity").find("input[name='quantity']");
      //  console.log(input);
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
          if (type == 'minus') {
            if (currentVal > 0) {
              input.val(currentVal - 1).change();
            }
          } else if (type == 'plus') {
            input.val(currentVal + 1).change();
          }
        } else {
          input.val(0);
        }
      });
    });  
   }  

}


